var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBandaids = function SvgIconBandaids(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.348 12 3.924 9.576 3.89 9.54a4 4 0 0 1 5.686-5.616L12 6.348l2.424-2.424.036-.034a4 4 0 0 1 5.616 5.686L17.652 12l2.424 2.424.034.036a4 4 0 0 1-5.686 5.616L12 17.652l-2.424 2.424-.036.034a4 4 0 0 1-5.616-5.686zm.457-7.145a2 2 0 0 1 1.376.503l2.405 2.405-2.823 2.823L5.358 8.18a2 2 0 0 1 1.447-3.326m3.78 11.383-2.404 2.405a2 2 0 0 1-2.823-2.824l2.405-2.405zM12 14.823 9.177 12 12 9.177 14.823 12zm1.414 1.415 2.405 2.405a2 2 0 0 0 2.824-2.824l-2.405-2.405zm2.824-5.652 2.405-2.405a2 2 0 0 0-2.824-2.823l-2.405 2.405z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBandaids;